import { render, staticRenderFns } from "./TDretouches.vue?vue&type=template&id=3e8314bd"
import script from "./TDretouches.vue?vue&type=script&lang=js"
export * from "./TDretouches.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports